import { useState } from "react";

// formik components
import { Formik, Form } from "formik";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";

// RasPm Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

// RasPm Dashboard examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// NewMilestone page components
import AddForm from "../components/AddForm";

// NewMilestone layout schemas for form and form fields
import validations from "../schemas/validations";
import form from "../schemas/form";
import initialValues from "../schemas/initialValues";

import { RequestService } from "services/RequestService";
import MDSnackbar from "components/MDSnackbar";
import { useNavigate } from "react-router-dom";
import CustomNavbar from "components/CustomNavbar";

function getSteps() {
  return ["معلومات المرحلة"];
}

function getStepContent(stepIndex, formData) {
  switch (stepIndex) {
    case 0:
      return <AddForm formData={formData} />;

    default:
      return null;
  }
}

function NewMilestone() {
  const [activeStep, setActiveStep] = useState(0);
  const steps = getSteps();
  const { formId, formField } = form;
  const currentValidation = validations[activeStep];
  const isLastStep = activeStep === steps.length - 1;
  const [show, setShow] = useState(false);
  const [error, setError] = useState(false);
  const toggleSnackbar = () => setShow(!show);
  const toggleSnackbar2 = () => setError(!error);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const handleBack = () => setActiveStep(activeStep - 1);
  // get project id from url
  const urlParams = new URLSearchParams(window.location.search);
  const projectId = urlParams.get("projectId");

  const submitForm = async (values, actions) => {
    await sleep(1000);

    await RequestService.post("Milestone", values)
      .then(async (result) => {
        setMessage(result.data.message);
        if (result.status === 200) {
          setMessage(result.data.message);
          setShow(!show);
          await sleep(1000);
          navigate("/pages/projects/milestones/view?id=" + projectId);
        } else {
          setError(!error);
        }
      })
      .catch((errorResponse) => {
        setMessage(errorResponse.response.data.Message);

        setError((prevError) => !prevError);
      });

    actions.setSubmitting(false);
    actions.resetForm();
    setActiveStep(0);
  };

  const handleSubmit = (values, actions) => {
    if (isLastStep) {
      submitForm(values, actions);
    } else {
      setActiveStep(activeStep + 1);
      actions.setTouched({});
      actions.setSubmitting(false);
    }
  };

  return (
    <DashboardLayout>
      <CustomNavbar
        title={`المشروع`}
        route={[
          { path: "pages/projects/viewprojects", display: "المشاريع" },
          { path: `projectinfo?id=${projectId}`, display: "المشروع" },
          { path: `milestones?id=${projectId}`, display: "المراحل" }
        ]}
      />

      <MDSnackbar
        color="success"
        icon="notifications"
        title="تمت العملية بنجاح"
        content={message}
        dateTime="0 seconds ago"
        open={show}
        close={toggleSnackbar}
      />
      <MDSnackbar
        color="error"
        icon="notifications"
        title=" فشلت العملية"
        content={message}
        dateTime="0 seconds ago"
        open={error}
        close={toggleSnackbar2}
      />
      <MDBox py={3} mb={20} height="65vh">
        <Grid container justifyContent="center" alignItems="center" sx={{ height: "100%", mt: 8 }}>
          <Grid item xs={12} lg={8}>
            <Formik
              initialValues={initialValues}
              validationSchema={currentValidation}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setValues, setFieldValue }) => (
                <Form id={formId} autoComplete="off">
                  <Card sx={{ height: "100%" }}>
                    <MDBox mx={2} mt={-3}>
                      <Stepper activeStep={activeStep} alternativeLabel>
                        {steps.map((label) => (
                          <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                          </Step>
                        ))}
                      </Stepper>
                    </MDBox>
                    <MDBox p={3}>
                      <MDBox>
                        {getStepContent(activeStep, {
                          values,
                          touched,
                          formField,
                          errors,
                          setValues,
                          setFieldValue,
                        })}
                        <MDBox mt={2} width="100%" display="flex" justifyContent="space-between">
                          {activeStep === 0 ? (
                            <MDBox />
                          ) : (
                            <MDButton variant="gradient" color="light" onClick={handleBack}>
                              السابق
                            </MDButton>
                          )}
                          <MDButton
                            disabled={isSubmitting}
                            type="submit"
                            variant="gradient"
                            color="dark"
                          >
                            {isLastStep ? "ارسال" : "التالي"}
                          </MDButton>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </Card>
                </Form>
              )}
            </Formik>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default NewMilestone;
